import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { findMenuTreeNode } from "@/utils/menu";
import { getMenus } from "@/services";
import styles from "./index.module.css";

const Iframe = () => {
  const location = useLocation();
  const path = location.pathname;
  const [iframeUrl, setIframeUrl] = useState("");

  /**
   * path变化时说明发生了页面切换,需要重新触发页面渲染
   */
  useEffect(() => {
    const getIframePageInfo = async () => {
      const { menus } = await getMenus();
      const node = findMenuTreeNode(menus, path); // 找到这个path对应菜单项的详细信息
      if (node && node.url) {
        setIframeUrl(node.url);
      }
    };

    getIframePageInfo();
  }, [path]);

  return (
    <>
      <iframe className={styles.iframePage} src={iframeUrl} />
    </>
  );
};

export default Iframe;
